import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.sass']
})
export class StepperComponent {

  @Input() steps: { label: string }[] = [];
  @Input() currentStep = 0;

  @Output() stepChange = new EventEmitter<number>();

  goTo(index: number): void {
    this.stepChange.emit(index);
  }
}
